// extracted by mini-css-extract-plugin
export default {"wrapper":"OffsetActions_wrapper__wxTCD","input":"OffsetActions_input__SoeTC","input__label":"OffsetActions_input__label__1RNlI","actions":"OffsetActions_actions__oaMFd"};